// extracted by mini-css-extract-plugin
export default {"root":"PaymentTab_root__MGOJA","title":"PaymentTab_title__d33r0","count":"PaymentTab_count__Q3VZ7"};